module.exports = {
      id: "2f9cf3bed1ee8d1b4012a02e3ff3fee8toiletEquipment-sink.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#2f9cf3bed1ee8d1b4012a02e3ff3fee8toiletEquipment-sink.svg",
      toString: function () {
        return this.url;
      }
    }